export const fullStoryEnabled = process.env.GATSBY_FULLSTORY_ORG
export const isProduction = process.env.NODE_ENV === `production`
